module.exports = __webpack_public_path__ + "static/img/home-item7.39e41a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item7.png
// module id = qK7Y
// module chunks = 21